var _templateObject, _templateObject2;

function _taggedTemplateLiteralLoose(strings, raw) { if (!raw) { raw = strings.slice(0); } strings.raw = raw; return strings; }

import styled, { css } from 'styled-components';
import { PLAN_LINE_HEIGHT } from './PlanCard';
import Tag from '../../../Tag';
var StyledTag = styled(Tag.Informative).attrs(function () {
  return {
    small: true
  };
})(_templateObject || (_templateObject = _taggedTemplateLiteralLoose(["\n  position: absolute;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n\n  ", "\n"])), function (props) {
  var plan = props.theme.yoga.components.card.plan;
  return css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteralLoose(["\n      top: ", "px;\n      left: ", "px;\n    "])), plan.tag.position.top + PLAN_LINE_HEIGHT, plan.tag.position.left);
});
StyledTag.displayName = 'PlanCard.Tag';
export default StyledTag;